import template from './am-operator-details-form.html';

class AmOperatorDetailsController {
  constructor(amOperatorsService, amStoreService, usersService) {
    'ngInject';

    this.opService = amOperatorsService;
    this.store = amStoreService;
    this.status = '';
    this.outAttrs = {};
    this.usersService = usersService;
    this.hasOperatorExpiryPermission = false;

    // date picker
    this.minDate = null;
    this.maxDate = null;
  }

  $onInit() {
    this.formName = this.formName || 'operatorDetailsForm';

    this.shouldHideExpiryForUser();
  }

  $onChanges() {}

  $onDestroy() {}

  /*
    This role ID comparison is for Sunbelt UK Expiry feature, it is not to be used for other accounts and roles unless approved
  */
  shouldHideExpiryForUser() {
    this.hasOperatorEditExpiryPermission = this.usersService.canUserEditExpiry();
  }
}

export default {
  template,
  controller: AmOperatorDetailsController,
  controllerAs: 'opDTFVm',
  bindings: {
    editName: '=',
    editAttrs: '=',
    formName: '=',
  },
};
